import { useMemo } from 'react';
import s from './SubmittedRequests.module.css';
import { Text } from '../../Language/Language';
import { Flex } from '@repo/ui/Flex';
import { Box } from '@repo/ui/Box';
import { Separator } from '@repo/ui/Separator';
import { useWorkflow } from '../../../workflow/hooks';
import { RequestCard } from '../../RequestCard/RequestCard';

export const SubmittedRequests = () => {
  const { submittedRequests, retailer, order } = useWorkflow();

  // Filter out requests that have claims shown in Claim History
  // A request with a corresponding claim (APPROVED, DENIED, etc.)
  const activeRequests = useMemo(() => {
    if (!submittedRequests || submittedRequests.length === 0) return [];

    // Build a set of claim IDs from order items (shown in Claim History)
    const claimIdsInHistory = new Set<string>();
    for (const item of order?.items ?? []) {
      for (const claim of item.claims ?? []) {
        claimIdsInHistory.add(claim.claimId);
      }
    }

    // Filter out requests that are already shown in Claim History
    return submittedRequests.filter(
      (request) => !claimIdsInHistory.has(request.id),
    );
  }, [submittedRequests, order?.items]);

  if (activeRequests.length === 0) {
    return null;
  }

  return (
    <>
      <Box padding={['py-32', 'md:py-64']}>
        <Separator size="lg" />
      </Box>
      <Flex
        padding={['px-24', 'md:px-0']}
        gap={['g-24', 'md:g-32']}
        direction="column"
      >
        <Flex gap="g-4" direction="column">
          <h1 className={s.title}>
            <Text langKey="pdx.item_selection.requests_header" />
          </h1>
          <p className={s.description}>
            <Text langKey="pdx.item_selection.requests_description" />
          </p>
        </Flex>
        <div className={s.grid}>
          {activeRequests.map((request) => (
            <RequestCard key={request.id} {...request} retailer={retailer} />
          ))}
        </div>
      </Flex>
    </>
  );
};
